module.exports = __webpack_public_path__ + "img/Untitled-3 copy.d44a8ee4.png";